export const VERSION = '1.5.73';
